import { useCountDown } from "hooks";

const Countdown = ({ date }) => {
  const { timeLeft, days, hours, minutes, seconds } = useCountDown(date);
  // const { timeLeft, days, hours, minutes, seconds } = useCountDown(
  //   "2023-02-10T19:40:00"
  // );

  const addLeadingZero = (val) => (val >= 10 ? val : `0${val}`);

  if (timeLeft < 1) return null;

  return (
    <div className="countdown-container">
      <span className="title">Старт продаж</span>
      <div className="countdown">
        {days > 0 && (
          <div className="countdown-item">
            <span>{addLeadingZero(days)}</span>
            <span>дней</span>
          </div>
        )}
        <div className="countdown-item">
          <span>{addLeadingZero(hours)}</span>
          <span>часов</span>
        </div>
        <div className="countdown-item">
          <span>{addLeadingZero(minutes)}</span>
          <span>минут</span>
        </div>
        {days === 0 && (
          <div className="countdown-item">
            <span>{addLeadingZero(seconds)}</span>
            <span>секунд</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default Countdown;
